import React, { useState } from 'react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import Breadcrumbs from '../components/Breadcrumbs';
import { useOrganization } from '../context/OrganizationContext';
import ApiTokensSection from '../components/ApiTokensSection';

const ApiKeys: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { currentOrganization } = useOrganization();

  return (
    <div className="h-full overflow-hidden flex flex-col bg-white dark:bg-slate-950">
      <TopBar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="flex flex-1 min-h-0 relative">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <div className="flex-1 overflow-y-auto relative">
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <Breadcrumbs items={[{ label: 'API Keys' }]} className="mb-6" />

            {/* Header */}
            <div className="mb-8">
              <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-1">API Keys</h1>
              <p className="text-sm text-gray-500 dark:text-slate-400">
                sk_sente_ keys your agents use to call the Sente API.
              </p>
            </div>

            {currentOrganization && <ApiTokensSection />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeys;
